// extracted by mini-css-extract-plugin
export default {"searchItem":"SearchItem_searchItem__QQtp1","allResults":"SearchItem_allResults__fq6AR"};